import instObj from '@/backend/axios-instances'

const resource = "/productionsheets/items"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    // can pass production_sheet_id as a param
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    // need production_sheet_id in body
    return instance.post(resource, data, { params: parameters });
  }
}
